import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import withPillNavigation from '../../shared/withPillNavigation.decorator';
import Numeral, { NumeralTypes } from '../../shared/numeral.component';
import DashboardPieChart from '../dashboardPieChart.component';
import { resourceTypes } from '../provisionQualitySinglePage/provisionQualitySingle.constants';

import LinkToSingle from './linkToSingle.component';

import {
  ConnectionsQualityPropTypes,
  BusinessesQualityPropTypes,
} from './propTypes';

const PillTypes = {
  CONNECTIONS_QUALITY: 'CONNECTIONS_QUALITY',
  BUSINESSES_QUALITY: 'BUSINESSES_QUALITY',
};

const PillDefinitions = [
  { label: 'Business', type: PillTypes.BUSINESSES_QUALITY },
  { label: 'Connection', type: PillTypes.CONNECTIONS_QUALITY },
];

const pieChartText = 'Provisions successfully completed';

const getFormattedValue = value => <Numeral type={NumeralTypes.NUMBER}>{value}</Numeral>;

class ProvisionQualityPieCharts extends PureComponent {
  static propTypes = {
    connectionsQuality: ConnectionsQualityPropTypes.isRequired,
    businessesQuality: BusinessesQualityPropTypes.isRequired,
    activePill: PropTypes.string.isRequired,
    selectSingleResource: PropTypes.func.isRequired,
  };

  render() {
    const {
      connectionsQuality,
      businessesQuality,
      activePill,
      selectSingleResource,
    } = this.props;

    return (
      <div className="provision-quality-pie-charts">
        {activePill === PillTypes.BUSINESSES_QUALITY ? businessesQuality.map(businessQuality => (
          <div className="pie-chart-container" key={businessQuality.businessCode}>
            <LinkToSingle
              value={businessQuality.businessCode}
              resourceType={resourceTypes.business}
              selectSingleResource={selectSingleResource}
            >
              <DashboardPieChart
                percentage={Math.floor(businessQuality.successPercent)}
                summaryText={(
                  <span>
                    {getFormattedValue(businessQuality.successComplete)}{' '}
                    of{' '}
                    {getFormattedValue(businessQuality.readyToTax)}
                  </span>
                )}
                text={pieChartText}
                label={businessQuality.businessDescription}
              />
            </LinkToSingle>
          </div>
        )) : connectionsQuality.map(connectionQuality => (
          <div className="pie-chart-container" key={connectionQuality.connectionErpName}>
            <LinkToSingle
              value={connectionQuality.connectionName}
              resourceType={resourceTypes.connection}
              selectSingleResource={selectSingleResource}
            >
              <DashboardPieChart
                percentage={Math.floor(connectionQuality.successPercent)}
                summaryText={(
                  <span>
                    {getFormattedValue(connectionQuality.successComplete)}{' '}
                    of{' '}
                    {getFormattedValue(connectionQuality.readyToTax)}
                  </span>
                )}
                text={pieChartText}
                label={connectionQuality.connectionErpName}
              />
            </LinkToSingle>
          </div>
        ))}
      </div>
    );
  }
}

export default withPillNavigation(
  () => PillDefinitions,
  {
    className: 'page-content-container',
  }
)(ProvisionQualityPieCharts);
